const listShopES = {
	title: "Registra tu Negocio",
	subtitle: "Recibe reservas en línea",
	shopName: "Nombre del negocio",
	ownerName: "Nombre del dueño",
	email: "Correo electrónico",
	phone: "Teléfono",
	shopDescription: "Descripción breve de tu negocio",
	registerShop: "Registrar Tienda",
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	signIn: "Iniciar sesión",
};

export default listShopES;
